import './App.css';
import Home from './pages/Home'
import Projects from './pages/Projects'
import AboutMe from './pages/AboutMe'
import Contact from './pages/Contact'
import Navbar from './components/NavBar'
import Bottombar from './components/BottomBar'
import { Routes, Route} from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { cyan, grey } from '@mui/material/colors';
import CssBaseline from '@mui/material/CssBaseline';


function App() {

  const theme = createTheme({
    typography: {
      fontFamily: 'Questrial, Arial, sans-serif',
    },
    palette: {
      primary: {
        main: grey[50],
      },
      secondary: {
        main: cyan[300],
      },
      dark:{
        main: '#000000',
      },
    },
  });


  return (
    <div className="App">
      <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar/>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      <Bottombar />
      </ThemeProvider>
    </div>
  );
}

export default App;
